@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

val spellNull_0 = SpellSkillId(0)
val spellCure_1 = SpellSkillId(1)
val spellCureII_2 = SpellSkillId(2)
val spellCureIII_3 = SpellSkillId(3)
val spellCureIV_4 = SpellSkillId(4)
val spellCureV_5 = SpellSkillId(5)
val spellCureVI_6 = SpellSkillId(6)
val spellCuraga_7 = SpellSkillId(7)
val spellCuragaII_8 = SpellSkillId(8)
val spellCuragaIII_9 = SpellSkillId(9)
val spellCuragaIV_10 = SpellSkillId(10)
val spellCuragaV_11 = SpellSkillId(11)
val spellRaise_12 = SpellSkillId(12)
val spellRaiseII_13 = SpellSkillId(13)
val spellPoisona_14 = SpellSkillId(14)
val spellParalyna_15 = SpellSkillId(15)
val spellBlindna_16 = SpellSkillId(16)
val spellSilena_17 = SpellSkillId(17)
val spellStona_18 = SpellSkillId(18)
val spellViruna_19 = SpellSkillId(19)
val spellCursna_20 = SpellSkillId(20)
val spellHoly_21 = SpellSkillId(21)
val spellHolyII_22 = SpellSkillId(22)
val spellDia_23 = SpellSkillId(23)
val spellDiaII_24 = SpellSkillId(24)
val spellDiaIII_25 = SpellSkillId(25)
val spellDiaIV_26 = SpellSkillId(26)
val spellDiaV_27 = SpellSkillId(27)
val spellBanish_28 = SpellSkillId(28)
val spellBanishII_29 = SpellSkillId(29)
val spellBanishIII_30 = SpellSkillId(30)
val spellBanishIV_31 = SpellSkillId(31)
val spellBanishV_32 = SpellSkillId(32)
val spellDiaga_33 = SpellSkillId(33)
val spellDiagaII_34 = SpellSkillId(34)
val spellDiagaIII_35 = SpellSkillId(35)
val spellDiagaIV_36 = SpellSkillId(36)
val spellDiagaV_37 = SpellSkillId(37)
val spellBanishga_38 = SpellSkillId(38)
val spellBanishgaII_39 = SpellSkillId(39)
val spellBanishgaIII_40 = SpellSkillId(40)
val spellBanishgaIV_41 = SpellSkillId(41)
val spellBanishgaV_42 = SpellSkillId(42)
val spellProtect_43 = SpellSkillId(43)
val spellProtectII_44 = SpellSkillId(44)
val spellProtectIII_45 = SpellSkillId(45)
val spellProtectIV_46 = SpellSkillId(46)
val spellProtectV_47 = SpellSkillId(47)
val spellShell_48 = SpellSkillId(48)
val spellShellII_49 = SpellSkillId(49)
val spellShellIII_50 = SpellSkillId(50)
val spellShellIV_51 = SpellSkillId(51)
val spellShellV_52 = SpellSkillId(52)
val spellBlink_53 = SpellSkillId(53)
val spellStoneskin_54 = SpellSkillId(54)
val spellAquaveil_55 = SpellSkillId(55)
val spellSlow_56 = SpellSkillId(56)
val spellHaste_57 = SpellSkillId(57)
val spellParalyze_58 = SpellSkillId(58)
val spellSilence_59 = SpellSkillId(59)
val spellBarfire_60 = SpellSkillId(60)
val spellBarblizzard_61 = SpellSkillId(61)
val spellBaraero_62 = SpellSkillId(62)
val spellBarstone_63 = SpellSkillId(63)
val spellBarthunder_64 = SpellSkillId(64)
val spellBarwater_65 = SpellSkillId(65)
val spellBarfira_66 = SpellSkillId(66)
val spellBarblizzara_67 = SpellSkillId(67)
val spellBaraera_68 = SpellSkillId(68)
val spellBarstonra_69 = SpellSkillId(69)
val spellBarthundra_70 = SpellSkillId(70)
val spellBarwatera_71 = SpellSkillId(71)
val spellBarsleep_72 = SpellSkillId(72)
val spellBarpoison_73 = SpellSkillId(73)
val spellBarparalyze_74 = SpellSkillId(74)
val spellBarblind_75 = SpellSkillId(75)
val spellBarsilence_76 = SpellSkillId(76)
val spellBarpetrify_77 = SpellSkillId(77)
val spellBarvirus_78 = SpellSkillId(78)
val spellSlowII_79 = SpellSkillId(79)
val spellParalyzeII_80 = SpellSkillId(80)
val spellRecallJugner_81 = SpellSkillId(81)
val spellRecallPashh_82 = SpellSkillId(82)
val spellRecallMeriph_83 = SpellSkillId(83)
val spellBaramnesia_84 = SpellSkillId(84)
val spellBaramnesra_85 = SpellSkillId(85)
val spellBarsleepra_86 = SpellSkillId(86)
val spellBarpoisonra_87 = SpellSkillId(87)
val spellBarparalyzra_88 = SpellSkillId(88)
val spellBarblindra_89 = SpellSkillId(89)
val spellBarsilencera_90 = SpellSkillId(90)
val spellBarpetra_91 = SpellSkillId(91)
val spellBarvira_92 = SpellSkillId(92)
val spellCura_93 = SpellSkillId(93)
val spellSacrifice_94 = SpellSkillId(94)
val spellEsuna_95 = SpellSkillId(95)
val spellAuspice_96 = SpellSkillId(96)
val spellReprisal_97 = SpellSkillId(97)
val spellRepose_98 = SpellSkillId(98)
val spellSandstorm_99 = SpellSkillId(99)
val spellEnfire_100 = SpellSkillId(100)
val spellEnblizzard_101 = SpellSkillId(101)
val spellEnaero_102 = SpellSkillId(102)
val spellEnstone_103 = SpellSkillId(103)
val spellEnthunder_104 = SpellSkillId(104)
val spellEnwater_105 = SpellSkillId(105)
val spellPhalanx_106 = SpellSkillId(106)
val spellPhalanxII_107 = SpellSkillId(107)
val spellRegen_108 = SpellSkillId(108)
val spellRefresh_109 = SpellSkillId(109)
val spellRegenII_110 = SpellSkillId(110)
val spellRegenIII_111 = SpellSkillId(111)
val spellFlash_112 = SpellSkillId(112)
val spellRainstorm_113 = SpellSkillId(113)
val spellWindstorm_114 = SpellSkillId(114)
val spellFirestorm_115 = SpellSkillId(115)
val spellHailstorm_116 = SpellSkillId(116)
val spellThunderstorm_117 = SpellSkillId(117)
val spellVoidstorm_118 = SpellSkillId(118)
val spellAurorastorm_119 = SpellSkillId(119)
val spellTeleportYhoat_120 = SpellSkillId(120)
val spellTeleportAltep_121 = SpellSkillId(121)
val spellTeleportHolla_122 = SpellSkillId(122)
val spellTeleportDem_123 = SpellSkillId(123)
val spellTeleportMea_124 = SpellSkillId(124)
val spellProtectra_125 = SpellSkillId(125)
val spellProtectraII_126 = SpellSkillId(126)
val spellProtectraIII_127 = SpellSkillId(127)
val spellProtectraIV_128 = SpellSkillId(128)
val spellProtectraV_129 = SpellSkillId(129)
val spellShellra_130 = SpellSkillId(130)
val spellShellraII_131 = SpellSkillId(131)
val spellShellraIII_132 = SpellSkillId(132)
val spellShellraIV_133 = SpellSkillId(133)
val spellShellraV_134 = SpellSkillId(134)
val spellReraise_135 = SpellSkillId(135)
val spellInvisible_136 = SpellSkillId(136)
val spellSneak_137 = SpellSkillId(137)
val spellDeodorize_138 = SpellSkillId(138)
val spellTeleportVahzl_139 = SpellSkillId(139)
val spellRaiseIII_140 = SpellSkillId(140)
val spellReraiseII_141 = SpellSkillId(141)
val spellReraiseIII_142 = SpellSkillId(142)
val spellErase_143 = SpellSkillId(143)
val spellFire_144 = SpellSkillId(144)
val spellFireII_145 = SpellSkillId(145)
val spellFireIII_146 = SpellSkillId(146)
val spellFireIV_147 = SpellSkillId(147)
val spellFireV_148 = SpellSkillId(148)
val spellBlizzard_149 = SpellSkillId(149)
val spellBlizzardII_150 = SpellSkillId(150)
val spellBlizzardIII_151 = SpellSkillId(151)
val spellBlizzardIV_152 = SpellSkillId(152)
val spellBlizzardV_153 = SpellSkillId(153)
val spellAero_154 = SpellSkillId(154)
val spellAeroII_155 = SpellSkillId(155)
val spellAeroIII_156 = SpellSkillId(156)
val spellAeroIV_157 = SpellSkillId(157)
val spellAeroV_158 = SpellSkillId(158)
val spellStone_159 = SpellSkillId(159)
val spellStoneII_160 = SpellSkillId(160)
val spellStoneIII_161 = SpellSkillId(161)
val spellStoneIV_162 = SpellSkillId(162)
val spellStoneV_163 = SpellSkillId(163)
val spellThunder_164 = SpellSkillId(164)
val spellThunderII_165 = SpellSkillId(165)
val spellThunderIII_166 = SpellSkillId(166)
val spellThunderIV_167 = SpellSkillId(167)
val spellThunderV_168 = SpellSkillId(168)
val spellWater_169 = SpellSkillId(169)
val spellWaterII_170 = SpellSkillId(170)
val spellWaterIII_171 = SpellSkillId(171)
val spellWaterIV_172 = SpellSkillId(172)
val spellWaterV_173 = SpellSkillId(173)
val spellFiraga_174 = SpellSkillId(174)
val spellFiragaII_175 = SpellSkillId(175)
val spellFiragaIII_176 = SpellSkillId(176)
val spellFiragaIV_177 = SpellSkillId(177)
val spellFiragaV_178 = SpellSkillId(178)
val spellBlizzaga_179 = SpellSkillId(179)
val spellBlizzagaII_180 = SpellSkillId(180)
val spellBlizzagaIII_181 = SpellSkillId(181)
val spellBlizzagaIV_182 = SpellSkillId(182)
val spellBlizzagaV_183 = SpellSkillId(183)
val spellAeroga_184 = SpellSkillId(184)
val spellAerogaII_185 = SpellSkillId(185)
val spellAerogaIII_186 = SpellSkillId(186)
val spellAerogaIV_187 = SpellSkillId(187)
val spellAerogaV_188 = SpellSkillId(188)
val spellStonega_189 = SpellSkillId(189)
val spellStonegaII_190 = SpellSkillId(190)
val spellStonegaIII_191 = SpellSkillId(191)
val spellStonegaIV_192 = SpellSkillId(192)
val spellStonegaV_193 = SpellSkillId(193)
val spellThundaga_194 = SpellSkillId(194)
val spellThundagaII_195 = SpellSkillId(195)
val spellThundagaIII_196 = SpellSkillId(196)
val spellThundagaIV_197 = SpellSkillId(197)
val spellThundagaV_198 = SpellSkillId(198)
val spellWaterga_199 = SpellSkillId(199)
val spellWatergaII_200 = SpellSkillId(200)
val spellWatergaIII_201 = SpellSkillId(201)
val spellWatergaIV_202 = SpellSkillId(202)
val spellWatergaV_203 = SpellSkillId(203)
val spellFlare_204 = SpellSkillId(204)
val spellFlareII_205 = SpellSkillId(205)
val spellFreeze_206 = SpellSkillId(206)
val spellFreezeII_207 = SpellSkillId(207)
val spellTornado_208 = SpellSkillId(208)
val spellTornadoII_209 = SpellSkillId(209)
val spellQuake_210 = SpellSkillId(210)
val spellQuakeII_211 = SpellSkillId(211)
val spellBurst_212 = SpellSkillId(212)
val spellBurstII_213 = SpellSkillId(213)
val spellFlood_214 = SpellSkillId(214)
val spellFloodII_215 = SpellSkillId(215)
val spellGravity_216 = SpellSkillId(216)
val spellGravityII_217 = SpellSkillId(217)
val spellMeteor_218 = SpellSkillId(218)
val spellComet_219 = SpellSkillId(219)
val spellPoison_220 = SpellSkillId(220)
val spellPoisonII_221 = SpellSkillId(221)
val spellPoisonIII_222 = SpellSkillId(222)
val spellPoisonIV_223 = SpellSkillId(223)
val spellPoisonV_224 = SpellSkillId(224)
val spellPoisonga_225 = SpellSkillId(225)
val spellPoisongaII_226 = SpellSkillId(226)
val spellPoisongaIII_227 = SpellSkillId(227)
val spellPoisongaIV_228 = SpellSkillId(228)
val spellPoisongaV_229 = SpellSkillId(229)
val spellBio_230 = SpellSkillId(230)
val spellBioII_231 = SpellSkillId(231)
val spellBioIII_232 = SpellSkillId(232)
val spellBioIV_233 = SpellSkillId(233)
val spellBioV_234 = SpellSkillId(234)
val spellBurn_235 = SpellSkillId(235)
val spellFrost_236 = SpellSkillId(236)
val spellChoke_237 = SpellSkillId(237)
val spellRasp_238 = SpellSkillId(238)
val spellShock_239 = SpellSkillId(239)
val spellDrown_240 = SpellSkillId(240)
val spellRetrace_241 = SpellSkillId(241)
val spellAbsorbACC_242 = SpellSkillId(242)
val spellAbsorbAttri_243 = SpellSkillId(243)
val spellMeteorII_244 = SpellSkillId(244)
val spellDrain_245 = SpellSkillId(245)
val spellDrainII_246 = SpellSkillId(246)
val spellAspir_247 = SpellSkillId(247)
val spellAspirII_248 = SpellSkillId(248)
val spellBlazeSpikes_249 = SpellSkillId(249)
val spellIceSpikes_250 = SpellSkillId(250)
val spellShockSpikes_251 = SpellSkillId(251)
val spellStun_252 = SpellSkillId(252)
val spellSleep_253 = SpellSkillId(253)
val spellBlind_254 = SpellSkillId(254)
val spellBreak_255 = SpellSkillId(255)
val spellVirus_256 = SpellSkillId(256)
val spellCurse_257 = SpellSkillId(257)
val spellBind_258 = SpellSkillId(258)
val spellSleepII_259 = SpellSkillId(259)
val spellDispel_260 = SpellSkillId(260)
val spellWarp_261 = SpellSkillId(261)
val spellWarpII_262 = SpellSkillId(262)
val spellEscape_263 = SpellSkillId(263)
val spellTractor_264 = SpellSkillId(264)
val spellTractorII_265 = SpellSkillId(265)
val spellAbsorbSTR_266 = SpellSkillId(266)
val spellAbsorbDEX_267 = SpellSkillId(267)
val spellAbsorbVIT_268 = SpellSkillId(268)
val spellAbsorbAGI_269 = SpellSkillId(269)
val spellAbsorbINT_270 = SpellSkillId(270)
val spellAbsorbMND_271 = SpellSkillId(271)
val spellAbsorbCHR_272 = SpellSkillId(272)
val spellSleepga_273 = SpellSkillId(273)
val spellSleepgaII_274 = SpellSkillId(274)
val spellAbsorbTP_275 = SpellSkillId(275)
val spellBlindII_276 = SpellSkillId(276)
val spellDreadSpikes_277 = SpellSkillId(277)
val spellGeohelix_278 = SpellSkillId(278)
val spellHydrohelix_279 = SpellSkillId(279)
val spellAnemohelix_280 = SpellSkillId(280)
val spellPyrohelix_281 = SpellSkillId(281)
val spellCryohelix_282 = SpellSkillId(282)
val spellIonohelix_283 = SpellSkillId(283)
val spellNoctohelix_284 = SpellSkillId(284)
val spellLuminohelix_285 = SpellSkillId(285)
val spellAddle_286 = SpellSkillId(286)
val spellKlimaform_287 = SpellSkillId(287)
val spellFireSpirit_288 = SpellSkillId(288)
val spellIceSpirit_289 = SpellSkillId(289)
val spellAirSpirit_290 = SpellSkillId(290)
val spellEarthSpirit_291 = SpellSkillId(291)
val spellThunderSpirit_292 = SpellSkillId(292)
val spellWaterSpirit_293 = SpellSkillId(293)
val spellLightSpirit_294 = SpellSkillId(294)
val spellDarkSpirit_295 = SpellSkillId(295)
val spellCarbuncle_296 = SpellSkillId(296)
val spellFenrir_297 = SpellSkillId(297)
val spellIfrit_298 = SpellSkillId(298)
val spellTitan_299 = SpellSkillId(299)
val spellLeviathan_300 = SpellSkillId(300)
val spellGaruda_301 = SpellSkillId(301)
val spellShiva_302 = SpellSkillId(302)
val spellRamuh_303 = SpellSkillId(303)
val spellDiabolos_304 = SpellSkillId(304)
val spellOdin_305 = SpellSkillId(305)
val spellAlexander_306 = SpellSkillId(306)
val spellCaitSith_307 = SpellSkillId(307)
val spellAnimusAugeo_308 = SpellSkillId(308)
val spellAnimusMinuo_309 = SpellSkillId(309)
val spellEnlight_310 = SpellSkillId(310)
val spellEndark_311 = SpellSkillId(311)
val spellEnfireII_312 = SpellSkillId(312)
val spellEnblizzardII_313 = SpellSkillId(313)
val spellEnaeroII_314 = SpellSkillId(314)
val spellEnstoneII_315 = SpellSkillId(315)
val spellEnthunderII_316 = SpellSkillId(316)
val spellEnwaterII_317 = SpellSkillId(317)
val spellMonomiIchi_318 = SpellSkillId(318)
val spellAishaIchi_319 = SpellSkillId(319)
val spellKatonIchi_320 = SpellSkillId(320)
val spellKatonNi_321 = SpellSkillId(321)
val spellKatonSan_322 = SpellSkillId(322)
val spellHyotonIchi_323 = SpellSkillId(323)
val spellHyotonNi_324 = SpellSkillId(324)
val spellHyotonSan_325 = SpellSkillId(325)
val spellHutonIchi_326 = SpellSkillId(326)
val spellHutonNi_327 = SpellSkillId(327)
val spellHutonSan_328 = SpellSkillId(328)
val spellDotonIchi_329 = SpellSkillId(329)
val spellDotonNi_330 = SpellSkillId(330)
val spellDotonSan_331 = SpellSkillId(331)
val spellRaitonIchi_332 = SpellSkillId(332)
val spellRaitonNi_333 = SpellSkillId(333)
val spellRaitonSan_334 = SpellSkillId(334)
val spellSuitonIchi_335 = SpellSkillId(335)
val spellSuitonNi_336 = SpellSkillId(336)
val spellSuitonSan_337 = SpellSkillId(337)
val spellUtsusemiIchi_338 = SpellSkillId(338)
val spellUtsusemiNi_339 = SpellSkillId(339)
val spellUtsusemiSan_340 = SpellSkillId(340)
val spellJubakuIchi_341 = SpellSkillId(341)
val spellJubakuNi_342 = SpellSkillId(342)
val spellJubakuSan_343 = SpellSkillId(343)
val spellHojoIchi_344 = SpellSkillId(344)
val spellHojoNi_345 = SpellSkillId(345)
val spellHojoSan_346 = SpellSkillId(346)
val spellKurayamiIchi_347 = SpellSkillId(347)
val spellKurayamiNi_348 = SpellSkillId(348)
val spellKurayamiSan_349 = SpellSkillId(349)
val spellDokumoriIchi_350 = SpellSkillId(350)
val spellDokumoriNi_351 = SpellSkillId(351)
val spellDokumoriSan_352 = SpellSkillId(352)
val spellTonkoIchi_353 = SpellSkillId(353)
val spellTonkoNi_354 = SpellSkillId(354)
val spellSiren_355 = SpellSkillId(355)
val spellParalyga_356 = SpellSkillId(356)
val spellSlowga_357 = SpellSkillId(357)
val spellHastega_358 = SpellSkillId(358)
val spellSilencega_359 = SpellSkillId(359)
val spellDispelga_360 = SpellSkillId(360)
val spellBlindga_361 = SpellSkillId(361)
val spellBindga_362 = SpellSkillId(362)
val spellSleepga_363 = SpellSkillId(363)
val spellSleepgaII_364 = SpellSkillId(364)
val spellBreakga_365 = SpellSkillId(365)
val spellGraviga_366 = SpellSkillId(366)
val spellDeath_367 = SpellSkillId(367)
val spellFoeRequiem_368 = SpellSkillId(368)
val spellFoeRequiemII_369 = SpellSkillId(369)
val spellFoeRequiemIII_370 = SpellSkillId(370)
val spellFoeRequiemIV_371 = SpellSkillId(371)
val spellFoeRequiemV_372 = SpellSkillId(372)
val spellFoeRequiemVI_373 = SpellSkillId(373)
val spellFoeRequiemVII_374 = SpellSkillId(374)
val spellFoeRequiemVIII_375 = SpellSkillId(375)
val spellHordeLullaby_376 = SpellSkillId(376)
val spellHordeLullabyII_377 = SpellSkillId(377)
val spellArmysPaeon_378 = SpellSkillId(378)
val spellArmysPaeonII_379 = SpellSkillId(379)
val spellArmysPaeonIII_380 = SpellSkillId(380)
val spellArmysPaeonIV_381 = SpellSkillId(381)
val spellArmysPaeonV_382 = SpellSkillId(382)
val spellArmysPaeonVI_383 = SpellSkillId(383)
val spellArmysPaeonVII_384 = SpellSkillId(384)
val spellArmysPaeonVIII_385 = SpellSkillId(385)
val spellMagesBallad_386 = SpellSkillId(386)
val spellMagesBalladII_387 = SpellSkillId(387)
val spellMagesBalladIII_388 = SpellSkillId(388)
val spellKnightsMinne_389 = SpellSkillId(389)
val spellKnightsMinneII_390 = SpellSkillId(390)
val spellKnightsMinneIII_391 = SpellSkillId(391)
val spellKnightsMinneIV_392 = SpellSkillId(392)
val spellKnightsMinneV_393 = SpellSkillId(393)
val spellValorMinuet_394 = SpellSkillId(394)
val spellValorMinuetII_395 = SpellSkillId(395)
val spellValorMinuetIII_396 = SpellSkillId(396)
val spellValorMinuetIV_397 = SpellSkillId(397)
val spellValorMinuetV_398 = SpellSkillId(398)
val spellSwordMadrigal_399 = SpellSkillId(399)
val spellBladeMadrigal_400 = SpellSkillId(400)
val spellHuntersPrelude_401 = SpellSkillId(401)
val spellArchersPrelude_402 = SpellSkillId(402)
val spellSheepfoeMambo_403 = SpellSkillId(403)
val spellDragonfoeMambo_404 = SpellSkillId(404)
val spellFowlAubade_405 = SpellSkillId(405)
val spellHerbPastoral_406 = SpellSkillId(406)
val spellChocoboHum_407 = SpellSkillId(407)
val spellShiningFantasia_408 = SpellSkillId(408)
val spellScopsOperetta_409 = SpellSkillId(409)
val spellPuppetsOperetta_410 = SpellSkillId(410)
val spellJestersOperetta_411 = SpellSkillId(411)
val spellGoldCapriccio_412 = SpellSkillId(412)
val spellDevoteeSerenade_413 = SpellSkillId(413)
val spellWardingRound_414 = SpellSkillId(414)
val spellGoblinGavotte_415 = SpellSkillId(415)
val spellCactuarFugue_416 = SpellSkillId(416)
val spellHonorMarch_417 = SpellSkillId(417)
val spellAriaofPassion_418 = SpellSkillId(418)
val spellAdvancingMarch_419 = SpellSkillId(419)
val spellVictoryMarch_420 = SpellSkillId(420)
val spellBattlefieldElegy_421 = SpellSkillId(421)
val spellCarnageElegy_422 = SpellSkillId(422)
val spellMassacreElegy_423 = SpellSkillId(423)
val spellSinewyEtude_424 = SpellSkillId(424)
val spellDextrousEtude_425 = SpellSkillId(425)
val spellVivaciousEtude_426 = SpellSkillId(426)
val spellQuickEtude_427 = SpellSkillId(427)
val spellLearnedEtude_428 = SpellSkillId(428)
val spellSpiritedEtude_429 = SpellSkillId(429)
val spellEnchantingEtude_430 = SpellSkillId(430)
val spellHerculeanEtude_431 = SpellSkillId(431)
val spellUncannyEtude_432 = SpellSkillId(432)
val spellVitalEtude_433 = SpellSkillId(433)
val spellSwiftEtude_434 = SpellSkillId(434)
val spellSageEtude_435 = SpellSkillId(435)
val spellLogicalEtude_436 = SpellSkillId(436)
val spellBewitchingEtude_437 = SpellSkillId(437)
val spellFireCarol_438 = SpellSkillId(438)
val spellIceCarol_439 = SpellSkillId(439)
val spellWindCarol_440 = SpellSkillId(440)
val spellEarthCarol_441 = SpellSkillId(441)
val spellLightningCarol_442 = SpellSkillId(442)
val spellWaterCarol_443 = SpellSkillId(443)
val spellLightCarol_444 = SpellSkillId(444)
val spellDarkCarol_445 = SpellSkillId(445)
val spellFireCarolII_446 = SpellSkillId(446)
val spellIceCarolII_447 = SpellSkillId(447)
val spellWindCarolII_448 = SpellSkillId(448)
val spellEarthCarolII_449 = SpellSkillId(449)
val spellLightningCarolII_450 = SpellSkillId(450)
val spellWaterCarolII_451 = SpellSkillId(451)
val spellLightCarolII_452 = SpellSkillId(452)
val spellDarkCarolII_453 = SpellSkillId(453)
val spellFireThrenody_454 = SpellSkillId(454)
val spellIceThrenody_455 = SpellSkillId(455)
val spellWindThrenody_456 = SpellSkillId(456)
val spellEarthThrenody_457 = SpellSkillId(457)
val spellLtngThrenody_458 = SpellSkillId(458)
val spellWaterThrenody_459 = SpellSkillId(459)
val spellLightThrenody_460 = SpellSkillId(460)
val spellDarkThrenody_461 = SpellSkillId(461)
val spellMagicFinale_462 = SpellSkillId(462)
val spellFoeLullaby_463 = SpellSkillId(463)
val spellGoddesssHymnus_464 = SpellSkillId(464)
val spellChocoboMazurka_465 = SpellSkillId(465)
val spellMaidensVirelai_466 = SpellSkillId(466)
val spellRaptorMazurka_467 = SpellSkillId(467)
val spellFoeSirvente_468 = SpellSkillId(468)
val spellAdventurersDirge_469 = SpellSkillId(469)
val spellSentinelsScherzo_470 = SpellSkillId(470)
val spellFoeLullabyII_471 = SpellSkillId(471)
val spellPiningNocturne_472 = SpellSkillId(472)
val spellRefreshII_473 = SpellSkillId(473)
val spellCuraII_474 = SpellSkillId(474)
val spellCuraIII_475 = SpellSkillId(475)
val spellCrusade_476 = SpellSkillId(476)
val spellRegenIV_477 = SpellSkillId(477)
val spellEmbrava_478 = SpellSkillId(478)
val spellBoostSTR_479 = SpellSkillId(479)
val spellBoostDEX_480 = SpellSkillId(480)
val spellBoostVIT_481 = SpellSkillId(481)
val spellBoostAGI_482 = SpellSkillId(482)
val spellBoostINT_483 = SpellSkillId(483)
val spellBoostMND_484 = SpellSkillId(484)
val spellBoostCHR_485 = SpellSkillId(485)
val spellGainSTR_486 = SpellSkillId(486)
val spellGainDEX_487 = SpellSkillId(487)
val spellGainVIT_488 = SpellSkillId(488)
val spellGainAGI_489 = SpellSkillId(489)
val spellGainINT_490 = SpellSkillId(490)
val spellGainMND_491 = SpellSkillId(491)
val spellGainCHR_492 = SpellSkillId(492)
val spellTemper_493 = SpellSkillId(493)
val spellArise_494 = SpellSkillId(494)
val spellAdloquium_495 = SpellSkillId(495)
val spellFiraja_496 = SpellSkillId(496)
val spellBlizzaja_497 = SpellSkillId(497)
val spellAeroja_498 = SpellSkillId(498)
val spellStoneja_499 = SpellSkillId(499)
val spellThundaja_500 = SpellSkillId(500)
val spellWaterja_501 = SpellSkillId(501)
val spellKaustra_502 = SpellSkillId(502)
val spellImpact_503 = SpellSkillId(503)
val spellRegenV_504 = SpellSkillId(504)
val spellGekkaIchi_505 = SpellSkillId(505)
val spellYainIchi_506 = SpellSkillId(506)
val spellMyoshuIchi_507 = SpellSkillId(507)
val spellYurinIchi_508 = SpellSkillId(508)
val spellKakkaIchi_509 = SpellSkillId(509)
val spellMigawariIchi_510 = SpellSkillId(510)
val spellHasteII_511 = SpellSkillId(511)
val spelldummy_512 = SpellSkillId(512)
val spellVenomShell_513 = SpellSkillId(513)
val spellMaelstrom_515 = SpellSkillId(515)
val spell_516 = SpellSkillId(516)
val spellMetallicBody_517 = SpellSkillId(517)
val spell_518 = SpellSkillId(518)
val spellScrewdriver_519 = SpellSkillId(519)
val spell_520 = SpellSkillId(520)
val spellMPDrainkiss_521 = SpellSkillId(521)
val spellDeathRay_522 = SpellSkillId(522)
val spell_523 = SpellSkillId(523)
val spellSandspin_524 = SpellSkillId(524)
val spell_525 = SpellSkillId(525)
val spell_526 = SpellSkillId(526)
val spellSmiteofRage_527 = SpellSkillId(527)
val spell_528 = SpellSkillId(528)
val spellBludgeon_529 = SpellSkillId(529)
val spellRefueling_530 = SpellSkillId(530)
val spellIceBreak_531 = SpellSkillId(531)
val spellBlitzstrahl_532 = SpellSkillId(532)
val spellSelfDestruct_533 = SpellSkillId(533)
val spellMysteriousLight_534 = SpellSkillId(534)
val spellColdWave_535 = SpellSkillId(535)
val spellPoisonBreath_536 = SpellSkillId(536)
val spellStinkingGas_537 = SpellSkillId(537)
val spellMementoMori_538 = SpellSkillId(538)
val spellTerrorTouch_539 = SpellSkillId(539)
val spellSpinalCleave_540 = SpellSkillId(540)
val spellBloodSaber_541 = SpellSkillId(541)
val spellDigest_542 = SpellSkillId(542)
val spellMandibularBite_543 = SpellSkillId(543)
val spellCursedSphere_544 = SpellSkillId(544)
val spellSickleSlash_545 = SpellSkillId(545)
val spell_546 = SpellSkillId(546)
val spellCocoon_547 = SpellSkillId(547)
val spellFilamentedHold_548 = SpellSkillId(548)
val spellPollen_549 = SpellSkillId(549)
val spell_550 = SpellSkillId(550)
val spellPowerAttack_551 = SpellSkillId(551)
val spell_552 = SpellSkillId(552)
val spell_553 = SpellSkillId(553)
val spellDeathScissors_554 = SpellSkillId(554)
val spellMagnetiteCloud_555 = SpellSkillId(555)
val spell_556 = SpellSkillId(556)
val spellEyesOnMe_557 = SpellSkillId(557)
val spell_558 = SpellSkillId(558)
val spellFreneticRip_560 = SpellSkillId(560)
val spellFrightfulRoar_561 = SpellSkillId(561)
val spell_562 = SpellSkillId(562)
val spellHecatombWave_563 = SpellSkillId(563)
val spellBodySlam_564 = SpellSkillId(564)
val spellRadiantBreath_565 = SpellSkillId(565)
val spellHelldive_567 = SpellSkillId(567)
val spellJetStream_569 = SpellSkillId(569)
val spellBloodDrain_570 = SpellSkillId(570)
val spellSoundBlast_572 = SpellSkillId(572)
val spellFeatherTickle_573 = SpellSkillId(573)
val spellFeatherBarrier_574 = SpellSkillId(574)
val spellJettatura_575 = SpellSkillId(575)
val spellYawn_576 = SpellSkillId(576)
val spellFootKick_577 = SpellSkillId(577)
val spellWildCarrot_578 = SpellSkillId(578)
val spellVoraciousTrunk_579 = SpellSkillId(579)
val spellHealingBreeze_581 = SpellSkillId(581)
val spellChaoticEye_582 = SpellSkillId(582)
val spellSheepSong_584 = SpellSkillId(584)
val spellRamCharge_585 = SpellSkillId(585)
val spellClawCyclone_587 = SpellSkillId(587)
val spellLowing_588 = SpellSkillId(588)
val spellDimensionalDeath_589 = SpellSkillId(589)
val spellHeatBreath_591 = SpellSkillId(591)
val spellBlankGaze_592 = SpellSkillId(592)
val spellMagicFruit_593 = SpellSkillId(593)
val spellUppercut_594 = SpellSkillId(594)
val spell1000Needles_595 = SpellSkillId(595)
val spellPineconeBomb_596 = SpellSkillId(596)
val spellSproutSmack_597 = SpellSkillId(597)
val spellSoporific_598 = SpellSkillId(598)
val spellQueasyshroom_599 = SpellSkillId(599)
val spell_600 = SpellSkillId(600)
val spell_601 = SpellSkillId(601)
val spell_602 = SpellSkillId(602)
val spellWildOats_603 = SpellSkillId(603)
val spellBadBreath_604 = SpellSkillId(604)
val spellGeistWall_605 = SpellSkillId(605)
val spellAwfulEye_606 = SpellSkillId(606)
val spellFrostBreath_608 = SpellSkillId(608)
val spellInfrasonics_610 = SpellSkillId(610)
val spellDisseverment_611 = SpellSkillId(611)
val spellActinicBurst_612 = SpellSkillId(612)
val spellReactorCool_613 = SpellSkillId(613)
val spellSalineCoat_614 = SpellSkillId(614)
val spellPlasmaCharge_615 = SpellSkillId(615)
val spellTemporalShift_616 = SpellSkillId(616)
val spellVerticalCleave_617 = SpellSkillId(617)
val spellBlastbomb_618 = SpellSkillId(618)
val spellBattleDance_620 = SpellSkillId(620)
val spellSandspray_621 = SpellSkillId(621)
val spellGrandSlam_622 = SpellSkillId(622)
val spellHeadButt_623 = SpellSkillId(623)
val spellBombToss_626 = SpellSkillId(626)
val spellFrypan_628 = SpellSkillId(628)
val spellFlyingHipPress_629 = SpellSkillId(629)
val spellHydroShot_631 = SpellSkillId(631)
val spellDiamondhide_632 = SpellSkillId(632)
val spellEnervation_633 = SpellSkillId(633)
val spellLightofPenance_634 = SpellSkillId(634)
val spellWarmUp_636 = SpellSkillId(636)
val spellFirespit_637 = SpellSkillId(637)
val spellFeatherStorm_638 = SpellSkillId(638)
val spellTailSlap_640 = SpellSkillId(640)
val spellHystericBarrage_641 = SpellSkillId(641)
val spellAmplification_642 = SpellSkillId(642)
val spellCannonball_643 = SpellSkillId(643)
val spellMindBlast_644 = SpellSkillId(644)
val spellExuviation_645 = SpellSkillId(645)
val spellMagicHammer_646 = SpellSkillId(646)
val spellZephyrMantle_647 = SpellSkillId(647)
val spellRegurgitation_648 = SpellSkillId(648)
val spellSeedspray_650 = SpellSkillId(650)
val spellCorrosiveOoze_651 = SpellSkillId(651)
val spellSpiralSpin_652 = SpellSkillId(652)
val spellAsuranClaws_653 = SpellSkillId(653)
val spellSubzeroSmash_654 = SpellSkillId(654)
val spellTriumphantRoar_655 = SpellSkillId(655)
val spellAcridStream_656 = SpellSkillId(656)
val spellBlazingBound_657 = SpellSkillId(657)
val spellPleniluneEmbrace_658 = SpellSkillId(658)
val spellDemoralizingRoar_659 = SpellSkillId(659)
val spellCimicineDischarge_660 = SpellSkillId(660)
val spellAnimatingWail_661 = SpellSkillId(661)
val spellBatteryCharge_662 = SpellSkillId(662)
val spellLeafstorm_663 = SpellSkillId(663)
val spellRegeneration_664 = SpellSkillId(664)
val spellFinalSting_665 = SpellSkillId(665)
val spellGoblinRush_666 = SpellSkillId(666)
val spellVanityDive_667 = SpellSkillId(667)
val spellMagicBarrier_668 = SpellSkillId(668)
val spellWhirlofRage_669 = SpellSkillId(669)
val spellBenthicTyphoon_670 = SpellSkillId(670)
val spellAuroralDrape_671 = SpellSkillId(671)
val spellOsmosis_672 = SpellSkillId(672)
val spellQuadContinuum_673 = SpellSkillId(673)
val spellFantod_674 = SpellSkillId(674)
val spellThermalPulse_675 = SpellSkillId(675)
val spellEmptyThrash_677 = SpellSkillId(677)
val spellDreamFlower_678 = SpellSkillId(678)
val spellOccultation_679 = SpellSkillId(679)
val spellChargedWhisker_680 = SpellSkillId(680)
val spellWindsofPromy_681 = SpellSkillId(681)
val spellDeltaThrust_682 = SpellSkillId(682)
val spellEvryoneGrudge_683 = SpellSkillId(683)
val spellReavingWind_684 = SpellSkillId(684)
val spellBarrierTusk_685 = SpellSkillId(685)
val spellMortalRay_686 = SpellSkillId(686)
val spellWaterBomb_687 = SpellSkillId(687)
val spellHeavyStrike_688 = SpellSkillId(688)
val spellDarkOrb_689 = SpellSkillId(689)
val spellWhiteWind_690 = SpellSkillId(690)
val spell_691 = SpellSkillId(691)
val spellSuddenLunge_692 = SpellSkillId(692)
val spellQuadrastrike_693 = SpellSkillId(693)
val spellVaporSpray_694 = SpellSkillId(694)
val spellThunderBreath_695 = SpellSkillId(695)
val spellOCounterstance_696 = SpellSkillId(696)
val spellAmorphicSpikes_697 = SpellSkillId(697)
val spellWindBreath_698 = SpellSkillId(698)
val spellBarbedCrescent_699 = SpellSkillId(699)
val spellNatMeditation_700 = SpellSkillId(700)
val spellTemUpheaval_701 = SpellSkillId(701)
val spellRendingDeluge_702 = SpellSkillId(702)
val spellEmbalmingEarth_703 = SpellSkillId(703)
val spellParalyzingTriad_704 = SpellSkillId(704)
val spellFoulWaters_705 = SpellSkillId(705)
val spellGlutinousDart_706 = SpellSkillId(706)
val spellRetinalGlare_707 = SpellSkillId(707)
val spellSubduction_708 = SpellSkillId(708)
val spellThrashingAssault_709 = SpellSkillId(709)
val spellErraticFlutter_710 = SpellSkillId(710)
val spellRestoral_711 = SpellSkillId(711)
val spellRailCannon_712 = SpellSkillId(712)
val spellDiffusionRay_713 = SpellSkillId(713)
val spellSinkerDrill_714 = SpellSkillId(714)
val spellMoltingPlumage_715 = SpellSkillId(715)
val spellNectarousDeluge_716 = SpellSkillId(716)
val spellSweepingGouge_717 = SpellSkillId(717)
val spellAtraLibations_718 = SpellSkillId(718)
val spellSearingTempest_719 = SpellSkillId(719)
val spellSpectralFloe_720 = SpellSkillId(720)
val spellAnvilLightning_721 = SpellSkillId(721)
val spellEntomb_722 = SpellSkillId(722)
val spellSaurianSlide_723 = SpellSkillId(723)
val spellPallingSalvo_724 = SpellSkillId(724)
val spellBlindingFulgor_725 = SpellSkillId(725)
val spellScouringSpate_726 = SpellSkillId(726)
val spellSilentStorm_727 = SpellSkillId(727)
val spellTenebralCrush_728 = SpellSkillId(728)
val spellThunderbolt_736 = SpellSkillId(736)
val spellHardenShell_737 = SpellSkillId(737)
val spellAbsoluteTerror_738 = SpellSkillId(738)
val spellGatesofHades_739 = SpellSkillId(739)
val spellTourbillion_740 = SpellSkillId(740)
val spellPyricBulwark_741 = SpellSkillId(741)
val spellBilgestorm_742 = SpellSkillId(742)
val spellBloodrake_743 = SpellSkillId(743)
val spellDroningWhirlwind_744 = SpellSkillId(744)
val spellCarcharianVerve_745 = SpellSkillId(745)
val spellBlisteringRoar_746 = SpellSkillId(746)
val spellUproot_747 = SpellSkillId(747)
val spellCrashingThunder_748 = SpellSkillId(748)
val spellPolarRoar_749 = SpellSkillId(749)
val spellMightyGuard_750 = SpellSkillId(750)
val spellCruelJoke_751 = SpellSkillId(751)
val spellCesspool_752 = SpellSkillId(752)
val spellTearingGust_753 = SpellSkillId(753)
val spell_754 = SpellSkillId(754)
val spell_755 = SpellSkillId(755)
val spell_756 = SpellSkillId(756)
val spell_757 = SpellSkillId(757)
val spell_758 = SpellSkillId(758)
val spell_759 = SpellSkillId(759)
val spell_760 = SpellSkillId(760)
val spell_761 = SpellSkillId(761)
val spell_762 = SpellSkillId(762)
val spell_763 = SpellSkillId(763)
val spell_764 = SpellSkillId(764)
val spell_765 = SpellSkillId(765)
val spell_766 = SpellSkillId(766)
val spell_767 = SpellSkillId(767)
val spellIndiRegen_768 = SpellSkillId(768)
val spellIndiPoison_769 = SpellSkillId(769)
val spellIndiRefresh_770 = SpellSkillId(770)
val spellIndiHaste_771 = SpellSkillId(771)
val spellIndiSTR_772 = SpellSkillId(772)
val spellIndiDEX_773 = SpellSkillId(773)
val spellIndiVIT_774 = SpellSkillId(774)
val spellIndiAGI_775 = SpellSkillId(775)
val spellIndiINT_776 = SpellSkillId(776)
val spellIndiMND_777 = SpellSkillId(777)
val spellIndiCHR_778 = SpellSkillId(778)
val spellIndiFury_779 = SpellSkillId(779)
val spellIndiBarrier_780 = SpellSkillId(780)
val spellIndiAcumen_781 = SpellSkillId(781)
val spellIndiFend_782 = SpellSkillId(782)
val spellIndiPrecision_783 = SpellSkillId(783)
val spellIndiVoidance_784 = SpellSkillId(784)
val spellIndiFocus_785 = SpellSkillId(785)
val spellIndiAttunement_786 = SpellSkillId(786)
val spellIndiWilt_787 = SpellSkillId(787)
val spellIndiFrailty_788 = SpellSkillId(788)
val spellIndiFade_789 = SpellSkillId(789)
val spellIndiMalaise_790 = SpellSkillId(790)
val spellIndiSlip_791 = SpellSkillId(791)
val spellIndiTorpor_792 = SpellSkillId(792)
val spellIndiVex_793 = SpellSkillId(793)
val spellIndiLanguor_794 = SpellSkillId(794)
val spellIndiSlow_795 = SpellSkillId(795)
val spellIndiParalysis_796 = SpellSkillId(796)
val spellIndiGravity_797 = SpellSkillId(797)
val spellGeoRegen_798 = SpellSkillId(798)
val spellGeoPoison_799 = SpellSkillId(799)
val spellGeoRefresh_800 = SpellSkillId(800)
val spellGeoHaste_801 = SpellSkillId(801)
val spellGeoSTR_802 = SpellSkillId(802)
val spellGeoDEX_803 = SpellSkillId(803)
val spellGeoVIT_804 = SpellSkillId(804)
val spellGeoAGI_805 = SpellSkillId(805)
val spellGeoINT_806 = SpellSkillId(806)
val spellGeoMND_807 = SpellSkillId(807)
val spellGeoCHR_808 = SpellSkillId(808)
val spellGeoFury_809 = SpellSkillId(809)
val spellGeoBarrier_810 = SpellSkillId(810)
val spellGeoAcumen_811 = SpellSkillId(811)
val spellGeoFend_812 = SpellSkillId(812)
val spellGeoPrecision_813 = SpellSkillId(813)
val spellGeoVoidance_814 = SpellSkillId(814)
val spellGeoFocus_815 = SpellSkillId(815)
val spellGeoAttunement_816 = SpellSkillId(816)
val spellGeoWilt_817 = SpellSkillId(817)
val spellGeoFrailty_818 = SpellSkillId(818)
val spellGeoFade_819 = SpellSkillId(819)
val spellGeoMalaise_820 = SpellSkillId(820)
val spellGeoSlip_821 = SpellSkillId(821)
val spellGeoTorpor_822 = SpellSkillId(822)
val spellGeoVex_823 = SpellSkillId(823)
val spellGeoLanguor_824 = SpellSkillId(824)
val spellGeoSlow_825 = SpellSkillId(825)
val spellGeoParalysis_826 = SpellSkillId(826)
val spellGeoGravity_827 = SpellSkillId(827)
val spellFira_828 = SpellSkillId(828)
val spellFiraII_829 = SpellSkillId(829)
val spellBlizzara_830 = SpellSkillId(830)
val spellBlizzaraII_831 = SpellSkillId(831)
val spellAera_832 = SpellSkillId(832)
val spellAeraII_833 = SpellSkillId(833)
val spellStonera_834 = SpellSkillId(834)
val spellStoneraII_835 = SpellSkillId(835)
val spellThundara_836 = SpellSkillId(836)
val spellThundaraII_837 = SpellSkillId(837)
val spellWatera_838 = SpellSkillId(838)
val spellWateraII_839 = SpellSkillId(839)
val spellFoil_840 = SpellSkillId(840)
val spellDistract_841 = SpellSkillId(841)
val spellDistractII_842 = SpellSkillId(842)
val spellFrazzle_843 = SpellSkillId(843)
val spellFrazzleII_844 = SpellSkillId(844)
val spellFlurry_845 = SpellSkillId(845)
val spellFlurryII_846 = SpellSkillId(846)
val spellAtomos_847 = SpellSkillId(847)
val spellReraiseIV_848 = SpellSkillId(848)
val spellFireVI_849 = SpellSkillId(849)
val spellBlizzardVI_850 = SpellSkillId(850)
val spellAeroVI_851 = SpellSkillId(851)
val spellStoneVI_852 = SpellSkillId(852)
val spellThunderVI_853 = SpellSkillId(853)
val spellWaterVI_854 = SpellSkillId(854)
val spellEnlightII_855 = SpellSkillId(855)
val spellEndarkII_856 = SpellSkillId(856)
val spellSandstormII_857 = SpellSkillId(857)
val spellRainstormII_858 = SpellSkillId(858)
val spellWindstormII_859 = SpellSkillId(859)
val spellFirestormII_860 = SpellSkillId(860)
val spellHailstormII_861 = SpellSkillId(861)
val spellThunderstormII_862 = SpellSkillId(862)
val spellVoidstormII_863 = SpellSkillId(863)
val spellAurorastormII_864 = SpellSkillId(864)
val spellFiraIII_865 = SpellSkillId(865)
val spellBlizzaraIII_866 = SpellSkillId(866)
val spellAeraIII_867 = SpellSkillId(867)
val spellStoneraIII_868 = SpellSkillId(868)
val spellThundaraIII_869 = SpellSkillId(869)
val spellWateraIII_870 = SpellSkillId(870)
val spellFireThrenodyII_871 = SpellSkillId(871)
val spellIceThrenodyII_872 = SpellSkillId(872)
val spellWindThrenodyII_873 = SpellSkillId(873)
val spellEarthThrenodyII_874 = SpellSkillId(874)
val spellLtngThrenodyII_875 = SpellSkillId(875)
val spellWaterThrenodyII_876 = SpellSkillId(876)
val spellLightThrenodyII_877 = SpellSkillId(877)
val spellDarkThrenodyII_878 = SpellSkillId(878)
val spellInundation_879 = SpellSkillId(879)
val spellDrainIII_880 = SpellSkillId(880)
val spellAspirIII_881 = SpellSkillId(881)
val spellDistractIII_882 = SpellSkillId(882)
val spellFrazzleIII_883 = SpellSkillId(883)
val spellAddleII_884 = SpellSkillId(884)
val spellGeohelixII_885 = SpellSkillId(885)
val spellHydrohelixII_886 = SpellSkillId(886)
val spellAnemohelixII_887 = SpellSkillId(887)
val spellPyrohelixII_888 = SpellSkillId(888)
val spellCryohelixII_889 = SpellSkillId(889)
val spellIonohelixII_890 = SpellSkillId(890)
val spellNoctohelixII_891 = SpellSkillId(891)
val spellLuminohelixII_892 = SpellSkillId(892)
val spellFullCure_893 = SpellSkillId(893)
val spellRefreshIII_894 = SpellSkillId(894)
val spellTemperII_895 = SpellSkillId(895)
val spellShantotto_896 = SpellSkillId(896)
val spellNaji_897 = SpellSkillId(897)
val spellKupipi_898 = SpellSkillId(898)
val spellExcenmille_899 = SpellSkillId(899)
val spellAyame_900 = SpellSkillId(900)
val spellNanaaMihgo_901 = SpellSkillId(901)
val spellCurilla_902 = SpellSkillId(902)
val spellVolker_903 = SpellSkillId(903)
val spellAjidoMarujido_904 = SpellSkillId(904)
val spellTrion_905 = SpellSkillId(905)
val spellZeid_906 = SpellSkillId(906)
val spellLion_907 = SpellSkillId(907)
val spellTenzen_908 = SpellSkillId(908)
val spellMihliAliapoh_909 = SpellSkillId(909)
val spellValaineral_910 = SpellSkillId(910)
val spellJoachim_911 = SpellSkillId(911)
val spellNajaSalaheem_912 = SpellSkillId(912)
val spellPrishe_913 = SpellSkillId(913)
val spellUlmia_914 = SpellSkillId(914)
val spellShikareeZ_915 = SpellSkillId(915)
val spellCherukiki_916 = SpellSkillId(916)
val spellIronEater_917 = SpellSkillId(917)
val spellGessho_918 = SpellSkillId(918)
val spellGadalar_919 = SpellSkillId(919)
val spellRainemard_920 = SpellSkillId(920)
val spellIngrid_921 = SpellSkillId(921)
val spellLehkoHabhoka_922 = SpellSkillId(922)
val spellNashmeira_923 = SpellSkillId(923)
val spellZazarg_924 = SpellSkillId(924)
val spellOvjang_925 = SpellSkillId(925)
val spellMnejing_926 = SpellSkillId(926)
val spellSakura_927 = SpellSkillId(927)
val spellLuzaf_928 = SpellSkillId(928)
val spellNajelith_929 = SpellSkillId(929)
val spellAldo_930 = SpellSkillId(930)
val spellMoogle_931 = SpellSkillId(931)
val spellFablinix_932 = SpellSkillId(932)
val spellMaat_933 = SpellSkillId(933)
val spellDShantotto_934 = SpellSkillId(934)
val spellStarSibyl_935 = SpellSkillId(935)
val spellKarahaBaruha_936 = SpellSkillId(936)
val spellCid_937 = SpellSkillId(937)
val spellGilgamesh_938 = SpellSkillId(938)
val spellAreuhat_939 = SpellSkillId(939)
val spellSemihLafihna_940 = SpellSkillId(940)
val spellElivira_941 = SpellSkillId(941)
val spellNoillurie_942 = SpellSkillId(942)
val spellLhuMhakaracca_943 = SpellSkillId(943)
val spellFerreousCoffin_944 = SpellSkillId(944)
val spellLilisette_945 = SpellSkillId(945)
val spellMumor_946 = SpellSkillId(946)
val spellUkaTotlihn_947 = SpellSkillId(947)
val spellKlara_948 = SpellSkillId(948)
val spellRomaaMihgo_949 = SpellSkillId(949)
val spellKuyinHathdenna_950 = SpellSkillId(950)
val spellRahal_951 = SpellSkillId(951)
val spellKoruMoru_952 = SpellSkillId(952)
val spellPieujeUC_953 = SpellSkillId(953)
val spellIShieldUC_954 = SpellSkillId(954)
val spellApururuUC_955 = SpellSkillId(955)
val spellJakohUC_956 = SpellSkillId(956)
val spellFlaviriaUC_957 = SpellSkillId(957)
val spellBabban_958 = SpellSkillId(958)
val spellAbenzio_959 = SpellSkillId(959)
val spellRughadjeen_960 = SpellSkillId(960)
val spellKukkiChebukki_961 = SpellSkillId(961)
val spellMargret_962 = SpellSkillId(962)
val spellChacharoon_963 = SpellSkillId(963)
val spellLheLhangavo_964 = SpellSkillId(964)
val spellArciela_965 = SpellSkillId(965)
val spellMayakov_966 = SpellSkillId(966)
val spellQultada_967 = SpellSkillId(967)
val spellAdelheid_968 = SpellSkillId(968)
val spellAmchuchu_969 = SpellSkillId(969)
val spellBrygid_970 = SpellSkillId(970)
val spellMildaurion_971 = SpellSkillId(971)
val spellHalver_972 = SpellSkillId(972)
val spellRongelouts_973 = SpellSkillId(973)
val spellLeonoyne_974 = SpellSkillId(974)
val spellMaximilian_975 = SpellSkillId(975)
val spellKayeelPayeel_976 = SpellSkillId(976)
val spellRobelAkbel_977 = SpellSkillId(977)
val spellKupofried_978 = SpellSkillId(978)
val spellSelhteus_979 = SpellSkillId(979)
val spellYoranOranUC_980 = SpellSkillId(980)
val spellSylvieUC_981 = SpellSkillId(981)
val spellAbquhbah_982 = SpellSkillId(982)
val spellBalamor_983 = SpellSkillId(983)
val spellAugust_984 = SpellSkillId(984)
val spellRosulatia_985 = SpellSkillId(985)
val spellTeodor_986 = SpellSkillId(986)
val spellUllegore_987 = SpellSkillId(987)
val spellMakkiChebukki_988 = SpellSkillId(988)
val spellKingofHearts_989 = SpellSkillId(989)
val spellMorimar_990 = SpellSkillId(990)
val spellDarrcuiln_991 = SpellSkillId(991)
val spellAAHM_992 = SpellSkillId(992)
val spellAAEV_993 = SpellSkillId(993)
val spellAAMR_994 = SpellSkillId(994)
val spellAATT_995 = SpellSkillId(995)
val spellAAGK_996 = SpellSkillId(996)
val spellIroha_997 = SpellSkillId(997)
val spellYgnas_998 = SpellSkillId(998)
val spellMonberaux_999 = SpellSkillId(999)
val spellCornelia_1002 = SpellSkillId(1002)
val spellMatsuiP_1003 = SpellSkillId(1003)
val spellExcenmilleS_1004 = SpellSkillId(1004)
val spellAyameUC_1005 = SpellSkillId(1005)
val spellMaatUC_1006 = SpellSkillId(1006)
val spellAldoUC_1007 = SpellSkillId(1007)
val spellNajaUC_1008 = SpellSkillId(1008)
val spellLionII_1009 = SpellSkillId(1009)
val spellZeidII_1010 = SpellSkillId(1010)
val spellPrisheII_1011 = SpellSkillId(1011)
val spellNashmeiraII_1012 = SpellSkillId(1012)
val spellLilisetteII_1013 = SpellSkillId(1013)
val spellTenzenII_1014 = SpellSkillId(1014)
val spellMumorII_1015 = SpellSkillId(1015)
val spellIngridII_1016 = SpellSkillId(1016)
val spellArcielaII_1017 = SpellSkillId(1017)
val spellIrohaII_1018 = SpellSkillId(1018)
val spellShantottoII_1019 = SpellSkillId(1019)